export default {
  lrfe: {
    table: {
      title: "Elementos enviados al SII - LRFE"
    }
  }
}
